import {connect} from 'react-redux';
import {SingleSelect as Component} from './SingleSelect';
import {
  selectQuestionOption,
  submitQuestionAnswer,
} from '@learningblocks/exp-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(selectQuestionOption(params));
    },
    submitAnswer: (id, type) => {
      dispatch(submitQuestionAnswer(id, type));
    },
  };
}
const SingleSelect = connect(mapStateToProps, mapDispatchToProps)(Component);

export {SingleSelect as SingleSelectWithRedux, Component as SingleSelect};
